import request from '@/utils/request'

export function findBaseEsimProducts(params) {
  return request({
    url: `/base_esim_products`,
    method: 'get',
    params
  })
}

export function findImportableBaseEsimProducts(params) {
  return request({
    url: `/base_esim_products/importable`,
    method: 'get',
    params
  })
}

export function createBaseEsimProduct(data) {
  return request({
    url: `/base_esim_products`,
    method: 'post',
    data
  })
}

export function findBaseEsimProductForm(id) {
  return request({
    url: `/base_esim_products/${id}/form`,
    method: 'get'
  })
}

export function updateBaseEsimProduct(id, data) {
  return request({
    url: `/base_esim_products/${id}`,
    method: 'put',
    data
  })
}

export function batchUpdateBaseEsimProductsEffective(ids, effective) {
  return request({
    url: `/base_esim_products/effective/batch`,
    method: 'patch',
    data: { ids, effective }
  })
}
